module.exports = __webpack_public_path__ + "img/slideVerify_10.271f8000.png";